module.exports = __webpack_public_path__ + "img/imagen-chicos.91d074c8.png";